import type { Container } from '@blocksuite/affine/global/di';
import {
  FileSizeLimitProvider,
  type IFileSizeLimitService,
} from '@blocksuite/affine/shared/services';
import { Extension } from '@blocksuite/affine/store';

/**
 * File size limit for BlockSuite editor blocks (images, attachments, etc.).
 *
 * The actual upload limit is enforced by:
 * 1. Backend: graphqlUploadExpress uses WORKSPACE_QUOTA.blobLimit
 * 2. Frontend: cloud/blob.ts fetches workspace.quota.blobLimit via GraphQL
 *
 * This extension only provides a client-side UI guard. We set it to
 * Number.MAX_SAFE_INTEGER so the real enforcement in the upload pipeline
 * is the single source of truth (quota.config.ts).
 */
export function patchFileSizeLimitExtension() {
  class StreamLainFileSizeLimitService
    extends Extension
    implements IFileSizeLimitService
  {
    maxFileSize = Number.MAX_SAFE_INTEGER;

    onOverFileSize() {
      // No-op: real enforcement happens in cloud/blob.ts upload pipeline
    }

    static override setup(di: Container) {
      di.override(FileSizeLimitProvider, StreamLainFileSizeLimitService);
    }
  }

  return StreamLainFileSizeLimitService;
}
